import {AppState} from "../../index";
import {equal, IBannerTemplate} from "./types";
import {createSelector} from "reselect";
import {ISelectOption} from "../../../components/FuseSelect";
import {sortByStringProp} from "../../../utils/sort";
import createCachedSelector from "re-reselect";
import {IActiveFolders} from "./files/types";

export const selectBannerTemplates = (state: AppState) => state.bannerTemplates.bannerTemplates;
export const selectBannerTemplateById = createCachedSelector(
    selectBannerTemplates,
    (state: AppState, id: string) => id,
    (bannerTemplates, id): IBannerTemplate | undefined => {
        if (bannerTemplates && bannerTemplates.byId) {
            return bannerTemplates.byId[id]
        }
    }
)(
    (selectBannerTemplates, id) => {
        return id
    }
)


export const selectBannerTemplatesFilter = (state: AppState) => state.bannerTemplates.filter;

export const selectActiveBannerTemplate = (state: AppState): IBannerTemplate => {
    return state.bannerTemplates.activeBannerTemplate
};

export const selectOriginalBannerTemplate = (state: AppState): IBannerTemplate | undefined => {
    return selectBannerTemplateById(state, state.bannerTemplates.activeBannerTemplate.id);
}

export const selectActiveFolders = (state: AppState): IActiveFolders => {
    return state.bannerTemplates.activeFolders
};

export const selectIsReloadingActiveFolders = (state: AppState): boolean => {
    return state.bannerTemplates.isReloadingActiveFolders
};

export const selectActiveMasterBannerTemplate = (state: AppState): IBannerTemplate | undefined => {
    return state.bannerTemplates.activeMasterBannerTemplate
};

export const selectIsBannerTemplateLoading = (state: AppState): boolean => {
    return state.bannerTemplates.isLoading
};

export const selectIsBannerTemplateSaving = (state: AppState): boolean => {
    return state.bannerTemplates.isSaving
};

export const selectHasActiveBannerTemplateChanged = createSelector(
    [selectBannerTemplates, selectActiveBannerTemplate],
    (bannerTemplates, active): boolean => {
        const origin = bannerTemplates.byId[active.id];
        return !equal(origin, active)
    });


export const selectVisibleMasterBannerTemplates = createSelector(
    [selectBannerTemplates],
    (bannerTemplates): IBannerTemplate[] => {
        return Object.values(bannerTemplates.byId).filter((item) => item.isMaster).sort((a, b): number => {
            return sortByStringProp(a, b, "name")
        })
    });


export const selectVisibleChildBannerTemplates = createSelector(
    [selectBannerTemplates, selectBannerTemplatesFilter],
    (bannerTemplates, filter): IBannerTemplate[] => {
        return Object.values(bannerTemplates.byId).filter((item) => {
            if (filter.parentId) {
                return !item.isMaster && item.parentId === filter.parentId
            }
            return !item.isMaster
        }).sort((a, b): number => {
            return sortByStringProp(a, b, "name")
        })
    });

export const createSelectBannerTemplatesOptions = (state: AppState, master: boolean) => createSelector(
    [selectVisibleMasterBannerTemplates, selectBannerTemplates],
    (masterTemplates, bannerTemplates): ISelectOption[] => {
        let values = Object.values(bannerTemplates.byId)
        if (master) {
            values = masterTemplates
        }
        return values.map((item) => {
            return {value: item.id, text: `${item.name}`}
        }).sort((a, b): number => {
            return sortByStringProp(a, b, "text")
        })
    })(state);
